import Component from './Export.vue';

export default {
  install(Vue) {
    Vue.component('BkfActionExport', Component);
  },
};
